import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-play-pause-button/jb-play-pause-button.css.ts
var jb_play_pause_button_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}:host{--border-width: 2px;--icon-size: 16px;--icon-size-lg: 24px;--size: 48px;--size-lg: 64px}button{align-items:center;background-color:rgba(0,0,0,0);block-size:var(--size);border:var(--border-width) solid var(--stroke-color, rgb(var(--rgb-primary, 20, 30, 85)));cursor:pointer;display:flex;inline-size:var(--size);justify-content:center;position:relative}@media(min-width: 1281px){button{block-size:var(--size-lg);inline-size:var(--size-lg)}button jb-icon{--_iconsize: 32px}}button:not(.playing) [iconName="material:pause-fill"]{display:none}button.playing [iconName="material:play_arrow-fill"]{display:none}`;

export {
  jb_play_pause_button_css_default
};
